import { Component, OnInit, Inject, ViewChild, ElementRef } from '@angular/core';
import { DriverManifiest } from 'src/app/core/interfaces/driverManifiest';
import { AdminUsersService } from '../../administration/admin-users/admin-users.service';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-open-detail-manifests',
  templateUrl: './open-detail-manifests.component.html',
  styleUrls: ['./open-detail-manifests.component.scss']
})
export class OpenDetailManifestsComponent implements OnInit {
  // @ViewChild('myElement', {static: false}) myElement: ElementRef;
  manifests: DriverManifiest[];
  blacklistNames: string[] = [];
  constructor(
    public dialogRef: MatDialogRef<OpenDetailManifestsComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private adminUsersService: AdminUsersService
  ) { }


  ngOnInit() {
    this.manifests = this.data && this.data.manifest && Array.isArray(this.data.manifest)
      ? this.data.manifest.filter(manifest => manifest && manifest.companyName) : [];
    this.adminUsersService.getBlackListNames().then(blacklistNames => {
      this.blacklistNames = blacklistNames;
    });
  }

  public isBlackList(manifest: DriverManifiest): boolean {
    if (!manifest || !manifest.companyName) return false;
    return this.blacklistNames.indexOf(String(manifest.companyName).toUpperCase().trim()) !== -1;
  }

}
